import { Location, Organization, Practitioner } from '@teschglobal/tg-fhir-react-components/dist/types'
import { useGlobalState } from '../store/useGlobalState'
import { getApiServer } from '../../utils/domain'

export default function useFhirConfig() {
  const setOrganization = useGlobalState((state) => state.setOrganization)
  const setLocation = useGlobalState((state) => state.setLocation)
  const setPractitioner = useGlobalState((state) => state.setPractitioner)

  const handleSelectOrganization = (organization: Organization) => {
    setOrganization(organization)
  }

  const handleSelectLocation = (location: Location) => {
    setLocation(location)
  }

  const handleSelectPractitioner = (practitioner: Practitioner) => {
    setPractitioner(practitioner)
  }

  const patientAccessFhirConfig = {
    url: getApiServer() + '/fhir/resource-by-id',
    includeCredentials: true,
  }

  const providerDirectoryFhirConfig = {
    url: getApiServer() + '/fhir/provider-resource-by-id',
    includeCredentials: true,
  }

  return {
    patientAccessFhirConfig,
    providerDirectoryFhirConfig,
    handleSelectOrganization,
    handleSelectLocation,
    handleSelectPractitioner,
  }
}
